import { Link } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import SecaoManifesto from '../components/SecaoManifesto'
import VideoExplicativo from '../components/VideoExplicativo'

export default function LandingPsicologo() {
  const { user, perfil } = useAuth()
  const homeRota = perfil?.role === 'medico' ? '/medico' : perfil?.role === 'paciente' ? '/app' : '/medico'

  return (
    <div
      className="min-h-screen text-white relative overflow-hidden"
      style={{
        background: `
          radial-gradient(ellipse at 20% 30%, rgba(139,92,246,0.45), transparent 55%),
          radial-gradient(ellipse at 80% 10%, rgba(196,181,253,0.18), transparent 50%),
          radial-gradient(ellipse at 70% 90%, rgba(124,58,237,0.25), transparent 55%),
          linear-gradient(135deg, #1e1b4b 0%, #2d1b5e 35%, #3b1f7a 65%, #1a0f3d 100%)
        `,
      }}
    >
      <div className="absolute inset-0 pointer-events-none opacity-30 [background-image:radial-gradient(circle_at_1px_1px,rgba(196,181,253,0.18)_1px,transparent_0)] [background-size:32px_32px]" />

      <div className="relative z-10">
        {/* HEADER */}
        <header className="px-6 py-5 max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-white/15 border border-white/25 flex items-center justify-center backdrop-blur-sm">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <path d="M3 12h4l3-9 4 18 3-9h4" />
              </svg>
            </div>
            <div className="text-2xl font-extrabold tracking-tight">
              anamis<span className="text-purple-300">.ai</span>
            </div>
          </Link>
          <nav className="flex items-center gap-2 sm:gap-3">
            {user ? (
              <Link to={homeRota} className="rounded-full px-5 py-2 text-sm font-semibold bg-purple-300 text-purple-950 hover:scale-105 transition">
                Abrir app →
              </Link>
            ) : (
              <>
                <Link to="/" className="rounded-full px-4 py-2 text-sm font-semibold text-white/85 hover:text-white transition hidden md:inline-block">
                  👤 Pacientes
                </Link>
                <Link to="/medicos" className="rounded-full px-4 py-2 text-sm font-semibold text-white/85 hover:text-white transition hidden md:inline-block">
                  🩺 Médicos
                </Link>
                <Link to="/planos" className="rounded-full px-4 py-2 text-sm font-semibold text-white/85 hover:text-white transition hidden lg:inline-block">
                  Planos
                </Link>
                <Link to="/login?role=medico" className="rounded-full px-4 py-2 text-sm font-semibold text-white/85 hover:text-white transition">
                  Entrar
                </Link>
                <Link to="/cadastro?role=medico" className="rounded-full px-5 py-2 text-sm font-semibold bg-purple-300 text-purple-950 hover:scale-105 transition shadow-lg shadow-purple-300/20">
                  Criar conta
                </Link>
              </>
            )}
          </nav>
        </header>

        {/* HERO */}
        <section className="max-w-7xl mx-auto px-6 pt-12 md:pt-24 pb-16 md:pb-24 animate-fade-up">
          <div className="grid md:grid-cols-12 gap-8 md:gap-12 items-center">
            <div className="md:col-span-7">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-[11px] font-semibold tracking-[0.18em] uppercase text-white/85 mb-7">
                <span className="text-base">🧠</span>
                Pra psicólogos & psiquiatras
              </span>

              <h1 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.98] mb-7 text-balance">
                Continuidade<br />
                <em className="text-purple-300 not-italic">entre</em><br />
                as sessões.
              </h1>

              <p className="text-lg md:text-xl text-white/85 leading-[1.7] font-light max-w-2xl mb-10 text-pretty">
                Sessão de 50 minutos é uma fotografia. Anamis te dá o <strong className="text-white">filme</strong> —
                humor diário, ansiedade, gatilhos, técnicas de coping, sinais de risco. Tudo registrado pelo paciente
                entre encontros, consolidado por IA antes da próxima sessão.
              </p>

              <div className="flex flex-wrap gap-3 mb-6">
                <Link
                  to="/cadastro?role=medico"
                  className="group inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-bold bg-purple-300 text-purple-950 hover:scale-105 active:scale-100 transition shadow-2xl shadow-purple-300/25"
                >
                  Criar conta grátis
                  <span className="transition group-hover:translate-x-1">→</span>
                </Link>
                <Link
                  to="/planos"
                  className="group inline-flex items-center gap-2 rounded-full px-7 py-3.5 font-bold bg-white/10 backdrop-blur-sm border border-white/25 hover:bg-white/20 hover:border-white/40 transition"
                >
                  Ver planos
                  <span className="transition group-hover:translate-x-1">→</span>
                </Link>
              </div>

              <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-white/70">
                <span className="flex items-center gap-1.5">✓ CRP/CRM compatível</span>
                <span className="flex items-center gap-1.5">✓ LGPD + sigilo profissional</span>
                <span className="flex items-center gap-1.5">✓ Banner CVV ético</span>
                <span className="flex items-center gap-1.5">✓ Free pra começar</span>
              </div>
            </div>

            <div className="md:col-span-5 relative mt-8 md:mt-0">
              <PreviewPsico />
            </div>
          </div>
        </section>

        {/* VÍDEO EXPLICATIVO — destaque centralizado entre hero e como funciona */}
        <section className="max-w-7xl mx-auto px-6 py-12 md:py-20">
          <div className="text-center mb-8">
            <span className="text-[11px] font-semibold tracking-[0.25em] uppercase text-purple-300">
              ▶ Em 75 segundos
            </span>
            <h2 className="font-display text-3xl md:text-4xl mt-3">
              Veja como funciona pra você
            </h2>
          </div>
          <div className="max-w-5xl mx-auto">
            <VideoExplicativo audiencia="psicologo" cor="#c4b5fd" />
          </div>
        </section>

        {/* SAÚDE MENTAL = FLUXO DIFERENTE */}
        <section className="max-w-7xl mx-auto px-6 py-16 md:py-24 border-t border-white/10">
          <div className="text-center mb-14">
            <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-purple-300">
              Saúde mental tem fluxo próprio
            </span>
            <h2 className="font-display text-4xl md:text-5xl leading-tight mt-3 text-balance max-w-3xl mx-auto">
              Não é check-in clínico adaptado
            </h2>
            <p className="text-white/75 mt-4 max-w-2xl mx-auto">
              Construímos um fluxo separado pra saúde mental — sem mapa corporal de dor,
              com escala de ansiedade, campos de pensamentos, gatilhos, técnicas de coping
              e flag explícita de ideação.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto">
            <FeatureCard
              emoji="📊"
              titulo="Humor + ansiedade"
              descricao="Escala 1-5 de humor e 0-10 de ansiedade. Paciente registra rápido, você vê padrão temporal entre sessões."
            />
            <FeatureCard
              emoji="💭"
              titulo="Pensamentos & gatilhos"
              descricao="Campos livres: pensamentos recorrentes, eventos que mexeram, técnicas de coping que ajudaram. Material pra próxima sessão."
            />
            <FeatureCard
              emoji="🚨"
              titulo="Flag de ideação"
              descricao="Checkbox opt-in pra sinalizar pensamentos de risco. Push imediato pra você — não espera próxima sessão."
            />
            <FeatureCard
              emoji="📋"
              titulo="Relatório pré-sessão"
              descricao="IA consolida tudo: humor predominante, ansiedade média, padrão temporal, sinais clínicos, F-codes (CID-10 mental)."
            />
            <FeatureCard
              emoji="⚠️"
              titulo="Detecção de risco"
              descricao="Análise semântica detecta sinais de risco em texto livre. Combina com flag manual. Alerta urgente em vermelho no relatório."
            />
            <FeatureCard
              emoji="💜"
              titulo="Banner CVV ético"
              descricao="Banner permanente no app do paciente com CVV 188 + SAMU 192. Compliance ético + responsabilidade legal."
            />
          </div>
        </section>

        {/* HETEROANAMNESE — diferencial único */}
        <section className="max-w-7xl mx-auto px-6 py-16 md:py-24 border-t border-white/10">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.25em] uppercase text-purple-300">
              <span className="bg-purple-300 text-purple-950 px-2 py-0.5 rounded font-extrabold">EXCLUSIVO</span>
              <span>Diferencial Anamis</span>
            </span>
            <h2 className="font-display text-3xl md:text-5xl leading-tight mt-4 text-balance max-w-4xl mx-auto">
              Informação colateral confidencial
            </h2>
            <p className="text-white/85 mt-5 max-w-3xl mx-auto text-pretty leading-relaxed">
              Em casos de mania, dependência química, transtornos de personalidade, adolescentes,
              demência — a percepção do paciente sobre si mesmo pode estar comprometida.
              <strong className="text-white"> Heteroanamnese é prática clínica clássica</strong> —
              cruzar versão do paciente com observação de família/cuidadores. Anamis traz isso pro digital.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5 max-w-6xl mx-auto mb-10">
            <CardEtapaHetero
              num="01"
              titulo="Paciente autoriza"
              texto="No perfil dele, paciente lista 1-N pessoas próximas (mãe, cônjuge, amigo) que podem mandar inputs sobre o quadro dele. Pode revogar a qualquer momento."
            />
            <CardEtapaHetero
              num="02"
              titulo="Pessoa próxima envia"
              texto="Recebe link único por email. Form curto: estado emocional percebido, mudanças observadas, gatilhos. Confidencial — não vê histórico clínico."
            />
            <CardEtapaHetero
              num="03"
              titulo="Você triangula"
              texto="Inputs aparecem em seção dedicada do painel, marcados como 'informação colateral — peso clínico secundário'. Paciente NÃO vê o conteúdo."
            />
          </div>

          {/* Princípios éticos */}
          <div className="rounded-3xl bg-white/5 border border-white/10 p-7 max-w-4xl mx-auto">
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-purple-300 mb-4">
              Construído com responsabilidade clínica
            </div>
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-3 text-sm text-white/85">
              <div>✓ Paciente autoriza explicitamente — autonomia preservada</div>
              <div>✓ Sigilo bidirecional — paciente não vê inputs, terceiro não vê histórico</div>
              <div>✓ Identificado pra você — sabe se foi mãe, cônjuge ou amigo</div>
              <div>✓ Peso clínico secundário — sistema marca visualmente</div>
              <div>✓ Conforme LGPD Art. 11 + CRP 011/2018</div>
              <div>✓ Paciente revoga acesso a qualquer momento</div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <span className="inline-flex items-center gap-2 text-xs text-white/60">
              <span className="bg-purple-300/20 text-purple-200 px-2.5 py-1 rounded-full font-bold">EM BREVE</span>
              <span>Roadmap próximo · concepção completa em <code className="text-purple-300">docs/HETEROANAMNESE.md</code></span>
            </span>
          </div>
        </section>

        {/* COMO FUNCIONA */}
        <section className="max-w-7xl mx-auto px-6 py-16 md:py-24 border-t border-white/10">
          <div className="text-center mb-14">
            <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-purple-300">
              Como funciona pra você
            </span>
            <h2 className="font-display text-4xl md:text-5xl leading-tight mt-3">
              Sessão começa antes da sala
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-3 md:gap-4">
            <PassoCard num="01" icone="🤝" titulo="Vincula paciente" descricao="Você manda link de convite. Ele cria conta grátis em 1 minuto e fica vinculado a você." />
            <PassoCard num="02" icone="📝" titulo="Paciente registra" descricao="No celular: humor, ansiedade, pensamentos, gatilhos. Quando quiser. Sem obrigação." />
            <PassoCard num="03" icone="🔔" titulo="Alerta de risco" descricao="Se paciente flagrar ideação, você recebe push imediato (pode contatar antes da sessão)." />
            <PassoCard num="04" icone="💜" titulo="Sessão preparada" descricao="No dia, 1 clique gera relatório consolidado. Você vê padrão da semana inteira em 30 segundos." />
          </div>
        </section>

        {/* COMPLIANCE / ÉTICA */}
        <section className="max-w-7xl mx-auto px-6 py-16 md:py-24 border-t border-white/10">
          <div className="grid md:grid-cols-2 gap-10 items-center">
            <div>
              <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-purple-300">
                Construído com responsabilidade
              </span>
              <h2 className="font-display text-3xl md:text-4xl leading-tight mt-3 mb-5">
                Saúde mental exige cuidado redobrado
              </h2>
              <p className="text-white/80 leading-relaxed mb-4">
                Anamis NÃO substitui crise — somos um <strong>registro pra consulta</strong>, não um serviço
                de emergência. Deixamos isso explícito no app do paciente, com banner permanente
                de CVV 188.
              </p>
              <p className="text-white/80 leading-relaxed">
                Sigilo profissional é tratado a sério: cardio que também atende seu paciente NÃO vê
                check-ins psicológicos dele (e vice-versa). Privacidade entre tipos é regra de banco
                de dados, não política a ser quebrada.
              </p>
            </div>
            <div className="rounded-3xl bg-white/8 backdrop-blur-sm border border-white/15 p-8">
              <ul className="space-y-4">
                <li className="flex gap-3">
                  <span className="text-2xl flex-shrink-0">🔒</span>
                  <div>
                    <div className="font-bold mb-0.5">Privacidade entre profissionais</div>
                    <div className="text-sm text-white/70">Cardio NÃO vê check-ins psicológicos. Psicólogo NÃO vê os clínicos. Regra de Firestore — não se contorna.</div>
                  </div>
                </li>
                <li className="flex gap-3">
                  <span className="text-2xl flex-shrink-0">🆘</span>
                  <div>
                    <div className="font-bold mb-0.5">CVV em destaque</div>
                    <div className="text-sm text-white/70">Banner amarelo no topo de TODO check-in psicológico: "188 / SAMU 192 / cvv.org.br".</div>
                  </div>
                </li>
                <li className="flex gap-3">
                  <span className="text-2xl flex-shrink-0">📚</span>
                  <div>
                    <div className="font-bold mb-0.5">LGPD + Art. 18</div>
                    <div className="text-sm text-white/70">Paciente pode pedir exclusão completa a qualquer momento. Apaga perfil + check-ins + análises.</div>
                  </div>
                </li>
                <li className="flex gap-3">
                  <span className="text-2xl flex-shrink-0">🤖</span>
                  <div>
                    <div className="font-bold mb-0.5">IA não treina com seus dados</div>
                    <div className="text-sm text-white/70">Claude (Anthropic) processa via API — política contratual proíbe usar dados de API pra treinar modelos.</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* PLANOS */}
        <section className="max-w-7xl mx-auto px-6 py-16 md:py-24 border-t border-white/10">
          <div className="text-center mb-12">
            <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-purple-300">
              Planos
            </span>
            <h2 className="font-display text-4xl md:text-5xl leading-tight mt-3">
              Comece grátis. Pacientes sempre grátis.
            </h2>
            <p className="text-white/75 mt-4 max-w-2xl mx-auto">
              Por enquanto usamos os mesmos planos dos médicos. Em breve teremos pacotes específicos pra saúde mental.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-4 max-w-5xl mx-auto mb-10">
            <PlanoCard
              nome="Free"
              preco="R$ 0"
              descricao="Pra conhecer"
              destaques={['Até 5 pacientes', 'Análise IA básica', 'Chat + linha do tempo', 'Suporte por comunidade']}
            />
            <PlanoCard
              nome="Essencial"
              preco="R$ 79"
              periodo="/mês"
              descricao="Pra consultório individual"
              destaques={['Até 50 pacientes', 'Relatório pré-sessão completo', 'Detecção de risco + push', 'Agenda + templates', 'Export FHIR']}
              destaque
            />
            <PlanoCard
              nome="PRO"
              preco="R$ 199"
              periodo="/mês"
              descricao="Pra consultório multi-profissional"
              destaques={['Pacientes ilimitados', 'Branding do consultório', 'Até 5 profissionais', 'Multi-consultórios', 'Suporte prioritário']}
            />
          </div>

          <div className="text-center">
            <Link
              to="/planos"
              className="group inline-flex items-center gap-2 rounded-full px-8 py-4 font-bold bg-purple-300 text-purple-950 hover:scale-105 transition shadow-2xl shadow-purple-300/25"
            >
              Ver detalhes & assinar
              <span className="transition group-hover:translate-x-1">→</span>
            </Link>
          </div>
        </section>

        {/* MANIFESTO — pitch core adaptado pra psicólogo */}
        <SecaoManifesto audiencia="psicologo" />

        {/* CTA FINAL */}
        <section className="max-w-7xl mx-auto px-6 py-16 md:py-24 border-t border-white/10 text-center">
          <h2 className="font-display text-4xl md:text-5xl mb-4">Comece a acompanhar seus pacientes</h2>
          <p className="text-white/80 max-w-xl mx-auto mb-8">
            Crie conta grátis em 1 minuto. Convide 1 paciente, faça uma análise. Sem cartão, sem compromisso.
          </p>
          <Link
            to="/cadastro?role=medico"
            className="inline-flex items-center gap-2 rounded-full px-8 py-4 font-bold bg-purple-300 text-purple-950 hover:scale-105 transition shadow-2xl shadow-purple-300/25"
          >
            Criar conta grátis →
          </Link>
        </section>

        {/* FOOTER */}
        <footer className="border-t border-white/10 mt-12">
          <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-xl bg-white/15 border border-white/25 flex items-center justify-center">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                  <path d="M3 12h4l3-9 4 18 3-9h4" />
                </svg>
              </div>
              <div className="text-lg font-extrabold">
                anamis<span className="text-purple-300">.ai</span>
              </div>
            </div>
            <div className="text-xs text-white/55 tracking-wider text-center md:text-right">
              © 2026 Anamis · São Paulo · LGPD compliant · suporte@pluma.tv
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}

function PassoCard({ num, icone, titulo, descricao }: { num: string; icone: string; titulo: string; descricao: string }) {
  return (
    <div className="rounded-3xl bg-white/8 backdrop-blur-sm border border-white/15 p-6 hover:bg-white/12 transition">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center font-display text-xl text-purple-300 bg-purple-300/15 border border-purple-300/30">
          {num}
        </div>
        <span className="text-2xl">{icone}</span>
      </div>
      <h3 className="font-bold text-lg mb-2">{titulo}</h3>
      <p className="text-sm text-white/75 leading-relaxed">{descricao}</p>
    </div>
  )
}

function CardEtapaHetero({ num, titulo, texto }: { num: string; titulo: string; texto: string }) {
  return (
    <div className="rounded-3xl bg-gradient-to-br from-purple-900/40 to-purple-950/40 border-2 border-purple-300/20 p-7 hover:border-purple-300/40 transition relative">
      <div className="absolute -top-4 -left-2 w-12 h-12 rounded-2xl bg-purple-300 text-purple-950 font-display text-xl flex items-center justify-center font-extrabold shadow-lg shadow-purple-300/30">
        {num}
      </div>
      <h3 className="font-display text-xl font-bold mb-2 mt-3 text-white">{titulo}</h3>
      <p className="text-sm text-white/80 leading-relaxed">{texto}</p>
    </div>
  )
}

function FeatureCard({ emoji, titulo, descricao }: { emoji: string; titulo: string; descricao: string }) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-6 hover:bg-white/8 transition">
      <div className="text-3xl mb-3">{emoji}</div>
      <h3 className="font-bold text-lg mb-2">{titulo}</h3>
      <p className="text-sm text-white/75 leading-relaxed">{descricao}</p>
    </div>
  )
}

function PlanoCard({ nome, preco, periodo, descricao, destaques, destaque }: { nome: string; preco: string; periodo?: string; descricao: string; destaques: string[]; destaque?: boolean }) {
  return (
    <div className={`rounded-3xl p-7 transition relative ${destaque ? 'bg-purple-300 text-purple-950 shadow-2xl shadow-purple-300/20 scale-105' : 'bg-white/8 backdrop-blur-sm border border-white/15 text-white hover:bg-white/12'}`}>
      {destaque && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-purple-950 text-purple-300 text-[10px] font-bold tracking-wider uppercase px-3 py-1 rounded-full">
          Mais popular
        </span>
      )}
      <h3 className="font-display text-2xl font-bold mb-1">{nome}</h3>
      <p className={`text-sm mb-4 ${destaque ? 'text-purple-950/70' : 'text-white/70'}`}>{descricao}</p>
      <div className="mb-5">
        <span className="text-3xl font-extrabold">{preco}</span>
        {periodo && <span className={`text-sm ${destaque ? 'text-purple-950/70' : 'text-white/70'}`}>{periodo}</span>}
      </div>
      <ul className="space-y-1.5 text-sm">
        {destaques.map((d, i) => (
          <li key={i} className="flex gap-2">
            <span className={destaque ? 'text-purple-950' : 'text-purple-300'}>✓</span>
            <span>{d}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}

function PreviewPsico() {
  return (
    <div className="relative mx-auto" style={{ maxWidth: 380 }}>
      <div className="absolute inset-0 -m-8 rounded-3xl bg-purple-500/15 blur-3xl animate-pulse-glow" />
      <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-purple-900/50 animate-float">
        {/* Header roxo */}
        <div className="bg-purple-900 px-5 py-4 text-white">
          <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-wider opacity-80 mb-1">
            <span>anamis.ai</span>
            <span>Pré-sessão psicológica</span>
          </div>
          <div className="font-display text-xl">Pré-sessão: Mariana Costa</div>
        </div>

        {/* Alerta urgente — destacado pra psico */}
        <div className="mx-5 my-3 px-3 py-2.5 rounded-lg bg-red-50 border-2 border-red-300">
          <div className="text-[9px] font-bold uppercase tracking-wider text-red-800">🚨 Sinal de risco detectado</div>
          <div className="text-[11px] text-red-900 mt-0.5">Paciente sinalizou ideação no check-in de quarta. Considere contato proativo.</div>
        </div>

        {/* Humor + ansiedade ao longo do tempo (mini chart) */}
        <div className="px-5 mb-3">
          <div className="text-[9px] font-bold uppercase tracking-wider text-slate-500 mb-2">Humor & ansiedade — última semana</div>
          <div className="flex items-end gap-1 h-12">
            {[3, 4, 2, 2, 3, 4, 3].map((h, i) => (
              <div key={i} className="flex-1 flex flex-col items-center justify-end">
                <div
                  className="w-full rounded-t bg-purple-400"
                  style={{ height: `${h * 20}%` }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Resumo */}
        <div className="px-5 mb-3">
          <div className="text-[9px] font-bold uppercase tracking-wider text-slate-500 mb-1">Relatório consolidado</div>
          <p className="text-[11px] text-slate-800 leading-snug">
            Humor predominantemente baixo (média 2.7/5), ansiedade alta (7-8/10) com pico em 04/05.
            Gatilho recorrente: trabalho. Coping: caminhada, escrita...
          </p>
        </div>

        {/* Hipóteses F-codes */}
        <div className="px-5 pb-4">
          <div className="text-[9px] font-bold uppercase tracking-wider text-slate-500 mb-2">Hipóteses</div>
          <div className="space-y-1.5">
            <div className="flex items-center gap-2">
              <div className="text-[10px] font-bold text-purple-700 min-w-[28px]">82%</div>
              <div className="h-1.5 flex-1 bg-slate-200 rounded-full overflow-hidden">
                <div className="h-full bg-purple-600" style={{ width: '82%' }} />
              </div>
              <div className="text-[10px] text-slate-700 min-w-[110px]">F41.1 TAG</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-[10px] font-bold text-purple-700 min-w-[28px]">68%</div>
              <div className="h-1.5 flex-1 bg-slate-200 rounded-full overflow-hidden">
                <div className="h-full bg-purple-600" style={{ width: '68%' }} />
              </div>
              <div className="text-[10px] text-slate-700 min-w-[110px]">F32.1 Depressão</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
